export default __webpack_public_path__ + "static/media/iconContact.e2ce2169.svg";